import React, { useEffect }  from "react";
import useForm from '../../../../hooks/useForm';
import { FormField } from '@prosolve/common-components-ui'
import { FaRegTrashAlt } from 'react-icons/fa';

export default ({
  prompt = {},
  isReadOnly,
  onChange,
  onDelete
}) => {
  const formSchema = {
    requiredFields: ['id', 'question', 'autoStartRecording'],
    initData: prompt
  }

  const formData = useForm(formSchema)

  useEffect(() => {
    onChange(formData.values)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      border: '1px solid #dedede',
      borderRadius: '5px',
      background: '#fdfdfd',
      padding: '10px',
      marginBottom: '10px'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        columnGap: '15px'
      }}>
        <FormField
          fieldId='question'
          type='textarea'
          label='Prompt Question'
          disabled={isReadOnly}
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='autoStartRecording'
          type='checkbox'
          label='Auto Start Recording'
          disabled={isReadOnly}
          style={{ alignSelf: 'flex-start' }}
          formData={formData}
        />
        <div>
          <FaRegTrashAlt
            onClick={() => !isReadOnly && onDelete(formData.values)}
            style={{
              position: 'relative',
              top: '4px',
              right: '4px',
              fontSize: '20px',
              cursor: isReadOnly ? 'default' : 'pointer',
              color: isReadOnly ? '#7E7E7E' : '#f85c5c'
            }}
          />
        </div>
      </div>
      
    </div>
  )
}